"use client";

import { useLocale, useTranslations } from "next-intl";
import { useRouter, usePathname } from "next/navigation";
import DropdownSelector from "../ui/DropdownSelector";

const languages = [
  { label: "language_en", value: "en", icon: "🇬🇧" },
  { label: "language_es", value: "es", icon: "🇪🇸" },
  { label: "language_de", value: "de", icon: "🇩🇪" },
  { label: "language_nl", value: "nl", icon: "🇳🇱" },
  { label: "language_hr", value: "hr", icon: "🇭🇷" },
  { label: "language_it", value: "it", icon: "🇮🇹" },
  { label: "language_pt", value: "pt", icon: "🇧🇷" },
  { label: "language_fr", value: "fr", icon: "🇫🇷" },
];

export default function LanguageSelector() {
  const t = useTranslations("Navbar");
  const locale = useLocale(); // idioma actual
  const router = useRouter();
  const pathname = usePathname();

  const handleSelect = (lang: string) => {
    const segments = pathname.split("/");

    // Reemplaza el locale actual en la ruta
    segments[1] = lang;
    const newPath = segments.join("/");

    router.replace(newPath);
  };

  const translated = languages.map((lang) => ({
    ...lang,
    label: t(lang.label),
  }));

  return (
    <DropdownSelector
      items={translated}
      selected={locale}
      onSelect={handleSelect}
      iconOnly
      label={t("language_title")}
      renderIcon={(item) => <span>{item.icon}</span>}
    />
  );
}
